import axiosFlow from '@/services/axios/axiosFlow'
import { isNullOrUndefined } from '@/utils/functions'

export default class FormularioService {
  static async get(itensPorPagina, ativo, nomeOuDescricao) {
    const params = new URLSearchParams()

    params.append('ItensPorPagina', itensPorPagina)

    if (!isNullOrUndefined(ativo)) {
      params.append('Ativo', ativo)
    }

    if (nomeOuDescricao) {
      params.append('NomeOuDescricao', nomeOuDescricao)
    }

    return axiosFlow.get(`formularios?${params}`).then(res => res.data.data.items)
  }

  static async getFormularioById(formularioId) {
    return axiosFlow.get(`formularios/${formularioId}`).then(res => res.data.data)
  }

  static async getFormulariosEstatisticas() {
    return axiosFlow.get('formularios/estatisticas').then(res => res.data.data)
  }

  static async getSecao(formularioId, secaoId) {
    return axiosFlow.get(`formularios/${formularioId}/secoes/${secaoId}`).then(res => res.data.data)
  }

  static async getTiposDeComponentes() {
    return axiosFlow.get('formularios/tipoElemento').then(res => res.data.data)
  }

  static async getComponenteNumericoSubtipos() {
    return axiosFlow.get('formularios/componente-numerico/subtipos').then(res => res.data.data)
  }

  static async getFormulariosComBot(filaId) {
    const params = new URLSearchParams()

    params.append('ItensPorPagina', 100)
    params.append('FormularioBot', true)
    params.append('Ativo', true)

    if (filaId) {
      params.append('FilaId', filaId.toString())
    }

    return axiosFlow.get(`formularios?${params}`).then(res => res.data.data.items)
  }

  static async criar(body) {
    return axiosFlow.post('formularios', body)
  }

  static async update(formularioId, body) {
    return axiosFlow.put(`formularios/${formularioId}`, body)
  }

  static async duplicarFormulario(formularioId, body) {
    return axiosFlow.post(`formularios/${formularioId}/duplicado`, body)
  }

  static async criarSecao(formularioId, body) {
    return axiosFlow.post(`formularios/${formularioId}/secoes`, body)
  }

  static async atualizarSecao(formularioId, secaoId, body) {
    return axiosFlow.put(`formularios/${formularioId}/secoes/${secaoId}`, body)
  }

  static async deletarSecao(formularioId, secaoId) {
    return axiosFlow.delete(`formularios/${formularioId}/secoes/${secaoId}`)
  }

  static async createComponente(filaId, secaoId, body) {
    return axiosFlow.post(`formularios/${filaId}/secoes/${secaoId}/elementos`, body)
  }

  static async updateComponente(filaId, secaoId, componenteId, body) {
    return axiosFlow.put(`formularios/${filaId}/secoes/${secaoId}/elementos/${componenteId}`, body)
  }

  static async ativarOuInativarFormulario(formularioId, body) {
    return axiosFlow.put(`formularios/${formularioId}/ativado`, body)
  }

  static async deletarComponente(formularioId, secaoId, componenteId) {
    return axiosFlow.delete(`formularios/${formularioId}/secoes/${secaoId}/elementos/${componenteId}`)
  }
}
